module.exports = __webpack_public_path__ + "static/11-7526d56cc11e1df712c8b508ac60aced.png";